import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import {
    defaultSubmissionsParams,
    submissionsParamsSchema,
} from './-SearchParams';
import { SubmissionsFilters } from './-Filters';
import { submissionsQuery } from '~/util/queries/staff/submissions';
import { SubmissionsTable } from './-SubmissionsTable';
import { useScopes } from '~/components/Providers/AuthProvider';
import { hasScope } from '~/auth/utils';

export const Route = createFileRoute(
    '/_authenticated/staff/_submissionsLayout/submissions/',
)({
    validateSearch: submissionsParamsSchema,
    search: {
        middlewares: [stripSearchParams(defaultSubmissionsParams)],
    },
    loaderDeps: ({
        search: {
            level,
            list,
            mobile,
            notes,
            priority,
            reviewer,
            status,
            submitter,
            page,
            per_page,
            sort,
            reverseSort,
        },
    }) => ({
        level,
        list,
        mobile,
        notes,
        priority,
        reviewer,
        status,
        submitter,
        page,
        per_page,
        sort,
        reverseSort,
    }),
    loader: async ({
        deps: { list, ...filters },
        context: { queryClient, auth },
    }) =>
        hasScope(auth, 'submission_edit_non_self_claimed')
            ? await queryClient.fetchQuery(submissionsQuery({ list, filters }))
            : {
                  page: 1,
                  pages: 1,
                  data: [],
              },
    component: RouteComponent,
    pendingMs: 3000,
});

function RouteComponent() {
    const { hasScope } = useScopes();
    return hasScope('submission_edit_non_self_claimed') ? (
        <div>
            <SubmissionsFilters />
            <SubmissionsTable />
        </div>
    ) : null;
}
